import CustomModal from "common/components/CustomModal/CustomModal";
import {
	ModalBody,
	ModalHeader,
	ModalPanel,
} from "common/components/CustomModal/Modal/ModalFrame";
import ModalHelper from "common/helpers/modalHelper";
import React, { useState } from "react";
import LoginForm from "./LoginForm";
import OAuthProviderRow from "./OAuthProviderRow";
import RegisterForm from "./RegisterForm";
import { useAuthStyles } from "./styles";

export default function AuthModal({ mode: initialMode }) {
	const styles = useAuthStyles();
	const [mode, setMode] = useState(initialMode ?? "login");
	const [notice, setNotice] = useState(null);
	const isLogin = mode === "login";

	const goToLogin = (message) => {
		setNotice(message ?? null);
		setMode("login");
	};

	return (
		<CustomModal>
			<ModalPanel className={styles.panel}>
				<ModalHeader onClose={() => ModalHelper.closeModal()}>
					{isLogin ? "Log In" : "Register"}
				</ModalHeader>
				<ModalBody className={styles.body}>
					<div className={styles.column}>
						{isLogin ? (
							<LoginForm
								notice={notice}
								onSwitchToRegister={() => setMode("register")}
							/>
						) : (
							<RegisterForm onSwitchToLogin={goToLogin} />
						)}
						<OAuthProviderRow
							label={isLogin ? "or continue with" : "or sign up with"}
						/>
					</div>
				</ModalBody>
			</ModalPanel>
		</CustomModal>
	);
}
